import { toIsoDate } from '@/core/lib/germanDate'
import { getAt } from '@/core/lib/path'
import { NO_UE_CAP } from '../lib/noUeCap'

export type AvgsPromotion = {
  agentur: {
    behoerde: string
    standort: string
  }
  coaching: {
    avgs_nummer: number
    inhalt_gruppen: string
    inhalt_einzel: string
    max_dauer: string
    gueltigkeit_beginn: string
    gueltigkeit_ende: string
    zeitl_umf_kategorie: string
    zeitl_umf_max_ue: number
  }
  teilnehmende: {
    kundennummer: string
  }
}

const s = (values: unknown, path: string) => {
  const v = getAt(values, path)
  return (v == null ? '' : String(v)).trim()
}

function toMaxUe(raw: string): number {
  return raw === '' ? NO_UE_CAP : parseInt(raw, 10)
}

function toLfdNr(raw: string): number {
  return raw === '' ? 0 : parseInt(raw, 10)
}

export function planAvgsPromotion(values: Record<string, unknown>): AvgsPromotion {
  return {
    agentur: {
      behoerde: s(values, 'Kostenträger.Behörde'),
      standort: s(values, 'Kostenträger.Standort'),
    },
    coaching: {
      avgs_nummer: toLfdNr(s(values, 'Teilnehmer.AVGS-Nummer (laufende Nummer)')),
      inhalt_gruppen: s(values, 'Maßnahme.Maßnahmeinhalt (Gruppenmaßnahme)'),
      inhalt_einzel: s(values, 'Maßnahme.Maßnahmeinhalt (Einzelmaßnahme)'),
      max_dauer: s(values, 'Maßnahme.Maximale Maßnahmedauer'),
      gueltigkeit_beginn: toIsoDate(s(values, 'Maßnahme.Gültigkeit Beginn')),
      gueltigkeit_ende: toIsoDate(s(values, 'Maßnahme.Gültigkeit Ende')),
      zeitl_umf_kategorie: s(values, 'Maßnahme.Zeitlicher Umfang (Kategorie)'),
      zeitl_umf_max_ue: toMaxUe(s(values, 'Maßnahme.Zeitlicher Umfang (max UE)')),
    },
    teilnehmende: {
      kundennummer: s(values, 'Teilnehmer.Kundennummer'),
    },
  }
}
